import React from "react";
import styled from "@emotion/styled";
import logoCRM from "../assets/logos/cruz-roja-logo.png";
import { FaFacebookSquare } from "react-icons/fa";
import { css } from "@emotion/react";

const Footer = () => {
  const DivOne = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    background-color: white;
    z-index: 1000;
    margin-top: 10px;
  `;

  const Logo = styled.img`
    height: 60px;
    margin-right: 20px;
    margin-left: 10px;

    @media (max-width: 768px) {
      display: none;
    }
  `;

  const DivMenu = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 20px;
  `;

  const MenuItem = styled.div`
    display: flex;
    align-items: center;
    font-size: 15px;
    cursor: pointer;
  `;

  return (
    <DivOne>
      <Logo src={logoCRM} alt="Logo izquierdo" />
      <DivMenu>
        <MenuItem>
          <FaFacebookSquare color="red" size={20} />
          &nbsp;/CONACCRM
        </MenuItem>
      </DivMenu>
    </DivOne>
  );
};

export default Footer;
